import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";
import LoadingAnimation from "../Loading/LoadingAnimation";

const ProtectedRoute = ({ children, requiredPermission }) => {
  const { isLoggedIn, loading } = useAuth();
  const location = useLocation();

  // Get permissions from localStorage
  const permissionsIDRaw = localStorage.getItem("PermissionIDs");
  if (!permissionsIDRaw || permissionsIDRaw === "null" || permissionsIDRaw === "undefined") {
    return <Navigate to="/" replace />;
  }
  let permissionsID = [];

  try {
    permissionsID = JSON.parse(permissionsIDRaw);
    if (!Array.isArray(permissionsID)) {
      permissionsID = [];
    }
  } catch (error) {

    permissionsID = permissionsIDRaw
      ?.split(",")
      .map(Number)
      .filter(Boolean) || [];
  }

  if (loading) {
    return <LoadingAnimation />;
  }

  if (!isLoggedIn) {
    if (location.pathname.startsWith("/documentsDetails")) {
      sessionStorage.setItem("redirectAfterLogin", location.pathname);
    }
    return <Navigate to="/" />;
  }

  if (requiredPermission && !permissionsID.includes(requiredPermission)) {
    return <Navigate to="/unauthorized" />;
  }
  return children;
};

export default ProtectedRoute;

